


















































































































































































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { getStoreId } from "../../../services/AuthService";
import { PickupService } from "../../../services/PickupService";
import { PickupsDTO, PickupDetailsDTO } from "../../../model/data.model";
import {
  GetPickupResults,
  PickupListItem,
  SearchParams,
  IPagination
} from "../../../model/component.model";
import { AlertBus } from "../../../plugins/alerts/AlertBus";
import Pagination from "../../shared/Pagination.vue";
import SearchDateRange, {
  DateRangeModel
} from "@/components/shared/SearchDateRange.vue";
import { format } from "date-fns";

type DateRangeModelFormatted = {
  dateStart?: string;
  dateEnd?: string;
};

@Component({
  components: {
    Pagination: Pagination,
    SearchDateRange
  }
})
export default class PickupsSearch extends Vue {
  @Prop() showSelectors: boolean;

  datesStartEnd: DateRangeModel = {
    dateStart: this.addDays(new Date(), -4),
    dateEnd: this.addMonths(new Date(), 1)
  };

  pickups: PickupListItem[] = [];
  allPickupsSelected = false;

  searchParams: SearchParams = {
    search: "",
    orderField: "pickupDate",
    orderDirection: "desc",
    totalElements: 0,
    totalPages: 0,
    numberOfElements: 0,
    page: 0,
    pageSize: 25
  };

  pagination: IPagination = {
    currentPage: 1,
    perPage: 25,
    totalElements: 0,
    perPageOptions: [25, 50, 100, 200, 500]
  };

  created() {
    this.pickups = [];
    this.search();
  }

  @Watch("searchParams.search")
  search() {
    // Ensure that selectAll radio checkbox is deselected
    this.selectAll(false);

    this.pickups = [];
    PickupService.searchStorePickups(
      this.$store.getters["customer/info"].customerId,
      getStoreId(),
      this.searchParams,
      this.getFormattedDates()
    )
      .then((res: GetPickupResults) => {
        this.pickups = [];
        res.pickups.content.forEach((item: PickupDetailsDTO) => {
          const o: PickupListItem = { ...(item as PickupListItem) };
          o.selected = false;
          this.pickups.push(o);
        });
        this.pagination.totalElements = res.searchParams.totalElements;
        this.searchParams.orderDirection = res.searchParams.orderDirection;
        this.searchParams.orderField = res.searchParams.orderField;
        this.searchParams.totalElements = res.searchParams.totalElements;
        this.searchParams.totalPages = res.searchParams.totalPages;
        this.searchParams.numberOfElements = res.searchParams.numberOfElements;
        this.searchParams.page = res.searchParams.page;
        this.searchParams.pageSize = res.searchParams.pageSize;
      })
      .catch(err => {
        this.$snotify.error(err.response.data.message);
      });
  }

  // Selection
  selectItem(item: PickupListItem) {
    if (item.handle) return;
    item.selected = !item.selected;
  }

  selectAll(value: boolean) {
    this.allPickupsSelected = value;
    this.pickups.forEach((pickup: PickupListItem) => {
      if (!pickup.handle) {
        pickup.selected = value;
      }
    });
  }

  pickupsSelected() {
    const p: PickupsDTO = { content: [] };
    p.content = this.pickups.filter(
      (pickup: PickupListItem) => pickup.selected
    );
    return p;
  }

  selectOrderFieldAndDirection(orderField: string) {
    if (this.searchParams.orderField === orderField) {
      const isAsc = this.searchParams.orderDirection === "asc";
      this.searchParams.orderDirection = isAsc ? "desc" : "asc";
    } else {
      this.searchParams.orderField = orderField;
      this.searchParams.orderDirection = "desc";
    }

    this.search();
  }

  searchHandler(pagination: IPagination) {
    this.pagination = pagination;
    this.searchParams.page = pagination.currentPage - 1;
    this.searchParams.pageSize = pagination.perPage;
    this.search();
  }

  confirmDeletion() {
    AlertBus.$alerts
      .confirm(this.$t("delete_pickups_title"))
      .then((val: boolean) => {
        if (val) {
          this.deleteSelectedPickups();
        }
      });
  }

  deleteSelectedPickups() {
    const pickups_to_delete = this.pickupsSelected() as PickupsDTO;
    PickupService.deletePickups(
      getStoreId(),
      pickups_to_delete,
      this.$store.getters["customer/config"].username,
      this.$store.getters["customer/config"].language
    ).then(() => {
      this.search();
    });
  }

  addMonths(date: Date, months: number) {
    const d = date.getDate();
    date.setMonth(date.getMonth() + +months);
    if (date.getDate() != d) {
      date.setDate(0);
    }
    return date;
  }
  addDays(date: Date, days: number) {
    const d = date.getDate() - 7;
    date.setDate(d);
    return date;
  }

  getFormattedDates() {
    const formattedDates = {} as DateRangeModelFormatted;
    if (this.datesStartEnd.dateStart) {
      formattedDates.dateStart = format(
        this.datesStartEnd.dateStart,
        "yyyy-MM-dd"
      );
    }
    if (this.datesStartEnd.dateEnd) {
      formattedDates.dateEnd = format(this.datesStartEnd.dateEnd, "yyyy-MM-dd");
    }
    return formattedDates;
  }
}
